module.exports = __webpack_public_path__ + "img/increasing_refund.e993824e.png";